import { BottonCommon } from "../../../common/components/BottonCommon/BottonCommonStyled";
import { StatusCommon } from "../../../common/components/StatusCommon/StatusCommon";
import { SidebarContainerCommon } from "../../AdminReports/AdminReportStyle";
import Sidebar from "../../Sidebar/Sidebar";
import ICReprogress from "../../../images/ic_reprogress.svg";
import GIFReload from "../../../images/gif_reload.gif";

import { useAsyncExecutor } from "async-executor-hook";
import { getErrorValueResponse } from "../../../common/error/Error";
import { PROCESSING } from "../../../utils/valueStaticConstants";
import {
  ContainerReloadButton,
  ContentMessage,
  LabelAtent,
  LabelVolanteNum,
} from "../PaymentStyles";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { HTTP_METHODS } from "../../../utils/constants";
import { Authorization } from "../../../common/AuthorizationCpt";

interface Props {
  onOutsideClick: () => void;
  statusSidebarInfo: any;
  onSucessReprogress: () => void;
  onErrorReprogress: (error: string) => void;
}
export const PaymentQuotedSidebarStatus = (props: Props) => {
  const {
    onOutsideClick,
    statusSidebarInfo,
    onSucessReprogress,
    onErrorReprogress,
  } = props;
  const { volanteId, volanteStatus, quotation_translate_error_message, id } =
    statusSidebarInfo;

  const separator = "|";
  const splitMessage = quotation_translate_error_message.split(separator);
  const messages = Array.isArray(splitMessage)
    ? splitMessage
    : [quotation_translate_error_message];

  const updateRepregressExecutor = useAsyncExecutor(
    (params: any) => {
      const { quotation_id } = params;
      return networkBackendRequest(
        `/quotations/reorder/${quotation_id}/`,
        HTTP_METHODS.POST,
        {
          quotation_id,
        }
      ).then((response) => response.json());
    },
    {
      onSuccess: (data) => {
        onSucessReprogress();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onErrorReprogress(errorMessage);
      },
    }
  );

  return (
    <Sidebar
      onOutsideClick={() => {
        onOutsideClick();
      }}
    >
      <SidebarContainerCommon width={"49.5rem"}>
        <LabelVolanteNum>Nº Volante {volanteId}</LabelVolanteNum>
        <LabelAtent>Atención</LabelAtent>
        <div style={{ width: "13rem", marginBottom: "3rem" }}>
          <StatusCommon
            label={volanteStatus.label}
            status={volanteStatus.category}
          />
        </div>
        <div>
          {messages.map((message, idx) => {
            return (
              <div key={idx}>
                <ContentMessage>{message}</ContentMessage>
              </div>
            );
          })}
        </div>
        <Authorization actions={["quotation.update_quotation_quoted"]}>
          <ContainerReloadButton>
            <BottonCommon
              onClick={() => {
                updateRepregressExecutor.execute({ quotation_id: id });
              }}
              backgroundColor="#88B13B"
              width="43rem"
              disabled={updateRepregressExecutor.status === PROCESSING}
            >
              <img
                src={
                  updateRepregressExecutor.status === PROCESSING
                    ? GIFReload
                    : ICReprogress
                }
                alt="reprogress"
                style={{ marginRight: "1.1rem" }}
                className="img-reload"
              />
              {"Reprocesar"}
            </BottonCommon>
          </ContainerReloadButton>
        </Authorization>
      </SidebarContainerCommon>
    </Sidebar>
  );
};
